"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.Icon = exports.Message = void 0;

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Utils = require("../../util/Utils");

/** @class FormError
 * @desc A private component shared between form components which display a validation error.
 * @param {node} value
 *    The error message
 * @param {string} [className]
 *    Optional classname to apply to the error container
 * @param {string} [data-id]
 *    Optional data-id
 * @private
 */

/**
* @class Message
* @memberof FormError
* @desc The child tag/object used to display the error message text
*
* @param {string} [data-id="form-error"]
*     To define the base "data-id" value for the top-level HTML container.
* @param {string} [className]
*     CSS classes to set on the top-level HTML container.
*/
var Message = function Message(_ref) {
  var className = _ref.className,
      dataId = _ref["data-id"],
      value = _ref.value;
  (0, _react.useEffect)(function () {
    var event = (0, _Utils.createCustomEvent)("ui-library-error", "FormErrorMessage");
    document.body.dispatchEvent(event);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: (0, _classnames.default)(className, "form-error-message")
  }, value);
};

exports.Message = Message;
Message.displayName = "FormErrorMessage";
Message.propTypes = {
  value: _propTypes.default.node,
  "data-id": _propTypes.default.string
};
Message.defaultProps = {
  "data-id": "form-error"
};
/**
* @class Icon
* @memberof FormError
* @desc The child tag/object used to display the error icon.
*
* @param {string} [data-id="form-error-icon"]
*     To define the base "data-id" value for the top-level HTML container.
*/

var Icon = function Icon(_ref2) {
  var dataId = _ref2["data-id"];
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: "form-error-icon"
  });
};

exports.Icon = Icon;
Icon.displayName = "FormErrorIcon";
Icon.propTypes = {
  "data-id": _propTypes.default.string
};
Icon.defaultProps = {
  "data-id": "form-error-icon"
};
var _default = {
  Icon: Icon,
  Message: Message
};
exports.default = _default;